// Join HTML element text together so it's read as one sentence by a screen reader.
// Also make sure plus and minus prices are read properly.
export const joinInnerTextForScreenReader = (element: HTMLElement | null) => {
  const elementHTML = element?.innerHTML || '';
  const divElement = document.createElement('div');

  divElement.innerHTML = elementHTML;

  divElement.querySelectorAll('[data-price]').forEach(element => {
    element.textContent = `\n${element.getAttribute('data-price')}`;
  });

  return divElement.innerText.replace(/\n+/giu, ', ');
};
